import Text from '../../../Text'

function TextContent({
  Tail,
  className,
  containerRef,
  content,
  tailClassName,
  tailProps,
  tailRef,
  textClassName,
  textRef,
}) {
  return (
    <div className={className} ref={containerRef}>
      <Text className={textClassName}>
        <span ref={textRef}>{content}</span>
        <span className={tailClassName} ref={tailRef}>
          <Tail {...tailProps} />
        </span>
      </Text>
    </div>
  )
}

export default TextContent
